import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Sets Open Graph + Twitter Card meta tags so drop/winner links unfurl
 * beautifully on iMessage, Instagram, Facebook, Twitter/X, Discord, etc.
 */
export default function OGMeta({ title, description, image, url }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
